import type { CustomComponent } from '../../config/types.js'

export type CustomSaveButton = CustomComponent
